import axios from 'axios';
import moment from 'moment';

class MitCSAILUsersService {
  constructor() {
  }
  requestGetUsers(searchterm) {
    return new Promise ((resolve, reject) => {
      if(typeof(searchterm) === 'undefined' || searchterm === null || (searchterm == '')){
        return resolve({users:[]});
      }
      axios.get('/api/v1/ldap/id/exactandpotential/'+searchterm)
        .then((response) => {
          resolve({users:response.data});
        })
        .catch((error) => {
          return reject(error.response.data);
        });

    });
  }


}

export default new MitCSAILUsersService();
